import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AccountApiService } from '../client/services/account.api.service';
import * as fromAction from './account.action';
import { AccountStoreService } from './account.store.service';
import { accountFeatureKey } from './account.state';
import { EffectHelperService } from '@modules/core/services/effect-helper.service';
@Injectable()
export class AccountStoreEffects {

  fecthAccountEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchAccounts),
    switchMap((payload) =>
      this.accountApiService
        .getAllAccount(payload.search, payload.filter, payload.pageIndex, payload.pageSize)
        .pipe(
          map((res) => {
            this.accountStoreService.addTotalCount(res.total);
            return this.effectHelperService.handleSuccess(fromAction.AddAccounts({ accounts: res.items }))
          }),
          this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
        )
    ),
  ));


  fecthAccountByIdEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.GetAccount),
    switchMap((payload) =>
      this.accountApiService.getAccountById(payload.id).pipe(
        map((item) => this.effectHelperService.handleSuccess(fromAction.AddAccount({ account: item }))),
        this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
      )
    )
  ));


  fecthCurrentAccountsEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchCurrentAccounts),
    switchMap((payload) =>
      this.accountApiService.fetchCurrentAccounts().pipe(
        map((accounts) => this.effectHelperService.handleSuccess(fromAction.AddCurrentAccount({ accounts }))),
        this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
      )
    )
  ));


  fecthKycDocumentEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchKycDocument),
    switchMap((payload) =>
      this.accountApiService.fetchKycDocuments(payload.accountId).pipe(
        map((kycDocuments) => this.effectHelperService.handleSuccess(fromAction.AddKycDocument({ kycDocuments }))),
        this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
      )
    )
  ));


  getAccountWalletEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.GetAccountWallet),
    switchMap((payload) =>
      this.accountApiService
        .getWalletByProvider(payload.provider, payload.providerId)
        .pipe(
          map((wallet) =>
            this.effectHelperService.handleSuccess(fromAction.UpdateWallet({ accountId: payload.id, wallet: wallet }))
          ),
          this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
        )
    )
  ));


  registerAccountEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.CreateAccount),
    switchMap((payload) =>
      this.accountApiService
        .registerAccount(payload.account)
        .pipe(
          map((account) =>
            this.effectHelperService.handleSuccess(fromAction.AddAccount({ account: account }), true, 'Account created successfully')
          ),
          this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
        )
    )
  ));


  updateAccountEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.ModifyAccount),
    switchMap((payload) =>
      this.accountApiService
        .updateAccount(payload.id, payload.update)
        .pipe(
          map((account) => this.effectHelperService.handleSuccess(fromAction.UpdateAccount({ id: payload.id, change: account }), true, 'Account updated successfully')),
          this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
        )
    )
  ));


  saveAccountWalletEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.SaveAccountWallet),
    switchMap((payload) =>
      this.accountApiService
        .registerAccountWallet(payload.id, payload.wallet)
        .pipe(map((wallet) => this.effectHelperService.handleSuccess(fromAction.AddWallet({ accountId: payload.id, wallet }), true, 'Account updated successfully')))),
    this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
  ));

  /*@Effect()
  saevAccountCardEffect$: Observable<Action> = this.actions$.pipe(
    ofType(fromAction.SaveAccountCard),
    switchMap((payload) =>
      this.cardApiService
        .cardPreRegistration(payload.id, payload.cardRegister)
        .pipe(
          switchMap((response) => {
            return this.cardApiService
              .mangoPayCardRegister(response.registrationUrl, {
                accessKeyRef: response.accessKey,
                cardCvx: payload.cardRegister.cardCVV,
                cardNumber: payload.cardRegister.cardNumber,
                cardExpirationDate: payload.cardRegister.cardExp,
                data: response.preregistrationData,
              })
              .pipe(
                switchMap((data) => {
                  return this.cardApiService
                    .cardRegistrationComplete(response.id, {
                      ...response,
                      registrationData: data,
                    })
                    .pipe(
                      map((card) => {
                        return fromAction.AddCard({
                          accountId: payload.id,
                          card: card,
                        });
                      }),
                      catchError((error) =>
                        observableOf(this.rootStoreService.handleError(error))
                      )
                    );
                })
              );
          }),
          tap((res) => {
            if (res.type === 'ADD ACCOUNT CARD') {
              this.accountStoreService.AddSuccess();
            }
          }),
          catchError((error) =>
            observableOf(this.rootStoreService.handleError(error))
          )
        )
    ),
    catchError((error) =>
      observableOf(this.rootStoreService.handleError(error))
    )
  );*/

  saveKycDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAction.SaveKycDocument),
      switchMap(({ accountId, kycDocument }) => {
        const { documentId, documentRef, file, type, identityType, documentSide } = kycDocument;
        return this.accountApiService
          .uploadKycDocument(accountId, documentId, documentRef, file, type, identityType, documentSide)
          .pipe(
            switchMap((_) =>
              this.accountApiService
                .fetchKycDocuments(accountId)
                .pipe(map((kycDocuments) => this.effectHelperService.handleSuccess(fromAction.AddKycDocument({ kycDocuments })))),
            )
          );
      }),
      this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
    )
  );

  submitKycDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAction.SubmitKycDocument),
      switchMap(({ accountId, documentRef }) => {
        return this.accountApiService.submitKycDocument(accountId, documentRef).pipe(
          switchMap((_) => {
            return this.accountApiService.fetchKycDocuments(accountId).pipe(
              map((kycDocuments) => this.effectHelperService.handleSuccess(fromAction.AddKycDocument({ kycDocuments }))),
              this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
            );
          })
        );
      })
    )
  );

  saveBankIbanNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAction.SaveBankIbanNumber),
      switchMap(({ accountId, token }) => {
        return this.accountApiService.addIBANToStripe(accountId, token).pipe(
          switchMap((_) => {
            return this.accountApiService.fetchCurrentAccounts().pipe(
              map((accounts) => this.effectHelperService.handleSuccess(fromAction.AddAccounts({ accounts }))),
              this.effectHelperService.handleError(fromAction.AddError, true, accountFeatureKey)
            );
          })
        );
      })
    )
  );

  constructor(
    private accountApiService: AccountApiService,
    private actions$: Actions,
    private accountStoreService: AccountStoreService,
    private effectHelperService: EffectHelperService
  ) { }
}
